import {store} from './store';

export const BASE_URL = process.env.NODE_ENV === 'development' ? 'https://modell.linkin.dev/' : '/';
export const CONTENT_URL = BASE_URL+'content/';
export const API_URL = BASE_URL+'api/v1/';

export const setPage = (dispatch, params) => {

    var page = {
        template: 'dashboard',
        params: params,
        showHeader: true,
        background: ''
    }

    if (params.page) {
        page.template = params.page;
    }



    if (params.page == 'registrera' && params.sub) {

        page.template = 'signup';
        page.showHeader = false;

        if (params.sub == 'modell') {
            page.template = 'signup-model';
        }

        getAuthToken(dispatch, null, null, () => {
            getEvent(dispatch, params.sub, store.getState().authState.token);
            dispatch({
                type: 'SET_PAGE',
                page: page
            })
        })

    } else if (params.page == 'profil') {

        page.template = 'profile';
        page.showHeader = false;

        if (params.sub == 'kontrakt' && params.sub2) {
            dispatch({
                type: 'PROFILE_FIELD_CHANGE',
                field: 'identity',
                value: params.sub2
            })
            page.template = 'profile';
        }

        getAuthToken(dispatch, null, null, () => {
            dispatch({
                type: 'SET_PAGE',
                page: page
            })
        })

    } else {

        if (params.page == 'login') {
            page.showHeader = false;
        }

        dispatch({
            type: 'SET_PAGE',
            page: page
        })

        let auth = JSON.parse(window.sessionStorage.getItem('auth'));
        if (!store.getState().authState.token && auth) {
            dispatch({
                type: 'AUTH_CLIENT',
                token: auth.token,
                user: auth.user,
                expires: auth.expires
            });
        }

        if (params.page === 'events' && params.sub) {
            page.template = 'event-form';
            dispatch({
                type: 'EVENT_FORM_RESET',
                validYears: store.getState().authState.user.defaults.validYears,
                eula: store.getState().authState.user.defaults.eula
            })

            if (params.sub == 'edit' && params.sub2) {
                var events = store.getState().eventState.orgEvents;
                if (events) {
                    var ie = events.map(e => e.id).indexOf(parseInt(params.sub2));

                    if (ie >= 0) {
                        dispatch({
                            type: 'EVENT_FORM_SET',
                            event: events[ie]
                        })
                    }
                }

            }
        }

        if (params.page == 'contracts' && params.sub == 'export') {
            page.template = 'contracts-export';
        }

        if (store.getState().authState.token) {

            if (params.page == 'signup') {
                getEvent(dispatch, params.sub, store.getState().authState.token);
            }

            if (page.template == 'dashboard') {
                findSince(dispatch);
            }

            if (params.page == 'models' && store.getState().modelState.models == null) {
                getModels(dispatch);
            }

            if (params.page == 'events' && store.getState().eventState.events == null) {
                getEvents(dispatch);
            }

            if (params.page == 'contracts' && store.getState().contractState.contracts == null) {
                getContracts(dispatch);
            }
        }

        if (params.page == 'contracts' && params.sub == 'filter' && params.sub2) {
            contractSearch(dispatch, {search: params.sub2, status: -1});
        }

        if (params.page == 'contracts' && params.sub == 'view' && params.sub2) {
            page.template = 'contract-single';
            if (store.getState().authState.token) {
                findContractCompany(dispatch, params.sub2);
            }
        }

        if (params.page === 'models' && params.sub) {
            page.template = 'models-single';


            var callback = () => {
                var models = store.getState().modelState.models;

                var i = models.map((model) => {
                    return model.id
                }).indexOf(parseInt(params.sub));

                if (i >= 0) {
                    dispatch({
                        type: 'MODEL_SET_CURRENT',
                        model: models[i]
                    });
                }
            }

            if (store.getState().modelState.models) {
                callback();
            } else {
                getModels(dispatch, callback);
            }

        }
    }

}

export const createEvent = (dispatch) => {
    var data = new FormData();

    var formState = store.getState().eventFormState.fields;
    for (var i in formState) {
        data.append(i, formState[i]);
    }

    var method = 'create';
    if (formState.id > 0) {
        method = 'edit';
    }

    fetch(API_URL + 'event/' + method,
        {
            credentials: 'include',
            method: 'POST',
            body: data
        })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'EVENT_FORM_CREATED'
            })
            getEvents(dispatch);
        } else {
            dispatch({
                type: 'EVENT_FORM_ERROR',
                status: rsp.status
            })
        }
    }).catch(() => {

    })
}


export const getEvents = (dispatch) => {
    dispatch({
        type: 'EVENTS_LOADING'
    })
    fetch(API_URL + 'event/list?__token=' + store.getState().authState.token, {
        credentials: 'include'
    })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'EVENTS_RECEIVED',
                events: rsp.rsp
            });
        } else if (rsp.status == 401) {
            doLogout(dispatch);
        }

    }).catch(() => {

    })
}

export const getEvent = (dispatch, slug, token) => {
    fetch(API_URL + 'event/find?slug=' + slug + '&__token=' + token, {
        credentials: 'include'
    }).then(function (response) {
        return response.json();
    }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'SET_REGISTER_EVENT',
                eula: rsp.rsp.eula,
                event: rsp.rsp.slug,
                compensation: rsp.rsp.compensation,
                company: rsp.rsp.company
            })
        } else if (rsp.status == 403) {
            doLogout(dispatch);
        } else {
            dispatch({
                type: 'SET_REGISTER_STATUS',
                status: rsp.status
            })
        }

    }).catch(() => {

    });
}

export const deleteEvent = (dispatch, id) => {

    fetch(API_URL + 'event/delete?id=' + id + '&__token=' + store.getState().authState.token, {
        credentials: 'include'
    }).then(function (response) {
        return response.json();
    }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'EVENT_DELETE',
                id: id
            })
        } else {

        }

    }).catch(() => {

    });

}

export const findProfile = (dispatch) => {

    var ssn = store.getState().profileState.ssn;
    var email = store.getState().profileState.email;
    var token = store.getState().authState.token;

    ssn = ssn.replace('-', '');
    if (ssn.length == 10) {
        ssn = "19" + ssn;
    }

    if (validateSSN(ssn) && validateEmail(email)) {
        dispatch({
            type: 'PROFILE_RECEIVING'
        })

        fetch(API_URL + 'profile/find?ssn=' + ssn + '&email='+email+'&__token=' + store.getState().authState.token, {
            credentials: 'include'
        }).then(function (response) {
            return response.json();
        }).then((rsp) => {

            if (rsp.status == 200) {
                dispatch({
                    type: 'PROFILE_RECEIVED',
                    profile: rsp.rsp
                })
            } else {
                dispatch({
                    type: 'PROFILE_RECEIVED_ERROR',
                    status: rsp.status
                })
            }

        }).catch(() => {

        });
    } else {
        dispatch({
            type: 'PROFILE_ERROR_FIELDS'
        })
    }

}

export const doLogin = (dispatch) => {
    dispatch({
        type: 'AUTH_LOADING'
    })
    fetch(API_URL + "user/login?user=" + store.getState().authState.username + "&pass=" + store.getState().authState.password).then(function (response) {
        return response.json();
    }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'AUTH_CLIENT',
                token: rsp.rsp.token,
                expires: rsp.rsp.expires,
                user: rsp.rsp.user
            });
            setPage(dispatch, {});

            window.sessionStorage.setItem('auth', JSON.stringify({
                token: rsp.rsp.token,
                expires: rsp.rsp.expires,
                user: rsp.rsp.user
            }));

        } else {
            dispatch({
                type: 'AUTH_FAIL'
            })
        }
    }).catch(() => {

    })
}

export const doLogout = (dispatch) => {
    fetch(API_URL + "user/logout").then(function (response) {
        return response.json();
    }).then((rsp) => {

        if (rsp.status == 200) {
            window.sessionStorage.clear();
            dispatch({
                type: 'AUTH_CLEAR'
            })

        }

    }).catch(() => {

    })
}

export const getAuthToken = (dispatch, username, password, cb) => {

    var url = API_URL + "user/token";

    if (username && password) {
        url = API_URL + "user/login?user=" + username + "&pass=" + password;
    }

    if (!store.getState().authState.token) {
        fetch(url).then(function (response) {
            return response.json();
        }).then((rsp) => {
            console.log(rsp.status)

            if (rsp.status == 200) {
                dispatch({
                    type: 'AUTH_CLIENT',
                    token: rsp.rsp.token,
                    expires: rsp.rsp.expires
                });

            }

            cb();
        }).catch(() => {

        })
    } else {
        cb();
    }

}

export const getModels = (dispatch, cb) => {
    dispatch({
        type: 'MODELS_LOADING'
    })
    fetch(API_URL + 'model/list?__token=' + store.getState().authState.token, {
        credentials: 'include'
    })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'MODELS_RECEIVED',
                models: rsp.rsp
            });

            if (cb){
                cb();
            }
        } else if (rsp.status == 401) {
            doLogout(dispatch);
        }

    }).catch(() => {

    })
}

export const findModel = (dispatch) => {

    let ssn = store.getState().registerState.ssn.replace('-', '');
    let email = store.getState().registerState.email;
    let type = store.getState().registerState.registerType;

    if (validateSSN(ssn) && validateEmail(email)) {
        fetch(API_URL + 'model/lookup?ssn=' + ssn + '&email=' + email + '&type='+ type + '&__token=' + store.getState().authState.token,
            {
                credentials: 'include'
            })
            .then(function (response) {
                return response.json();
            }).then((rsp) => {

            if (rsp.status == 200) {
                console.log(rsp.rsp);
                dispatch({
                    type: 'MODEL_RECEIVED',
                    model: rsp.rsp
                });
            } else if (rsp.status == 404 || rsp.status == 429) {
                dispatch({
                    type: 'REGISTER_OPEN_STEP_2'
                })
            } else if (rsp.status == 406) {
                dispatch({
                    type: 'REGISTER_INVALID_AGE'
                })
            }

            if (rsp.status == 403) {

            }

        }).catch(() => {

        })
    } else {
        dispatch({
            type: 'REGISTER_INVALID_SSN'
        })
    }

}

export const editModel = (dispatch) => {
    var data = new FormData();
    data.append('data', JSON.stringify(store.getState().profileState.profile));
    data.append('__token', store.getState().authState.token);
    fetch(API_URL + 'model/edit',
        {
            credentials: 'include',
            method: 'POST',
            body: data
        })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'PROFILE_EDIT_COMPLETE'
            })
        } else if (rsp.status == 400) {
            dispatch({
                type: 'PROFILE_EDIT_INVALID',
                data: rsp.data
            })
        }  else {
            dispatch({
                type: 'PROFILE_EDIT_INVALID_UNKNOWN'
            })
        }

    }).catch(() => {

    })
}

export const saveModel = (dispatch) => {
    var data = new FormData();
    data.append('data', JSON.stringify(store.getState().registerModelState));
    data.append('__token', store.getState().authState.token);
    fetch(API_URL + 'model/create',
        {
            credentials: 'include',
            method: 'POST',
            body: data
        })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status === 200) {
            dispatch({
                type: 'REGISTER_MODEL_COMPLETE'
            })
        } else if (rsp.status === 400 || rsp.status === 409) {
            dispatch({
                type: 'REGISTER_MODEL_INVALID',
                data: rsp.data,
                status: rsp.status
            })
        }  else {
            dispatch({
                type: 'REGISTER_MODEL_INVALID_UNKNOWN'
            })
        }

    }).catch(() => {

    })
}

export const findSince = (dispatch, since) => {
    fetch(API_URL + 'contract/list?since=' + Date.now() + '&__token=' + store.getState().authState.token,
        {
            credentials: 'include'
        })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'SINCE_CONTRACT_RECEIVED',
                contracts: rsp.rsp
            });
        }

        if (rsp.status == 403) {

        }

    }).catch(() => {

    })
}

export const findContractCompany = (dispatch, id) => {

    var token = store.getState().authState.token

    dispatch({
        type: 'CONTRACT_SINGLE_LOADING'
    });

    fetch(API_URL + 'contract/find?id=' + id + '&__token=' + token, {
        credentials: 'include'
    }).then(function (response) {
        return response.json();
    }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'CONTRACT_SINGLE_RECEIVED',
                contract: rsp.rsp
            })
        } else if (rsp.status == 403) {
            doLogout(dispatch);
        } else {

        }

    }).catch(() => {

    });
}


export const getContracts = (dispatch) => {
    dispatch({
        type: 'CONTRACTS_LOADING'
    })
    fetch(API_URL + 'contract/list?__token=' + store.getState().authState.token, {
        credentials: 'include'
    })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'CONTRACTS_RECEIVED',
                contracts: rsp.rsp
            });

            contractSearch(dispatch);
        } else if (rsp.status == 401) {
            doLogout(dispatch);
        }

    }).catch(() => {

    })
}

export const editContract = (dispatch, id, status) => {

    dispatch({
        type: 'CONTRACT_STATUS_LOADING'
    })

    fetch(API_URL + 'contract/edit?id=' + id + '&status=' + status + '__token=' + store.getState().authState.token,
        {
            credentials: 'include',
            method: 'POST'
        })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.rsp == true) {
            dispatch({
                type: 'CONTRACT_STATUS_CHANGE',
                id: id,
                status: status
            })
        }

    }).catch(() => {

    })
}

export const saveContract = (dispatch) => {
    var data = new FormData();
    data.append('data', JSON.stringify(store.getState().registerState));
    data.append('__token', store.getState().authState.token);

    let errors = [];

    console.log(store.getState().registerState);
	if (!store.getState().registerState.profile) {
        errors.push('profile');
	}

    if (!store.getState().registerState.terms) {
	    errors.push('terms');
    }

    if (errors.length > 0) {
	    dispatch({
		    type: 'REGISTER_INVALID',
		    data: errors
	    })
        return;
    }

    fetch(API_URL + 'contract/create',
        {
            credentials: 'include',
            method: 'POST',
            body: data
        })
        .then(function (response) {
            return response.json();
        }).then((rsp) => {

        if (rsp.status == 200) {
            dispatch({
                type: 'REGISTER_COMPLETE'
            })
        } else if (rsp.status == 400 && rsp.data) {
            dispatch({
                type: 'REGISTER_INVALID',
                data: rsp.data
            })
        } else {
            dispatch({
                type: 'REGISTER_INVALID_UNKNOWN',
                errorCode: rsp.status
            })
        }

    }).catch(() => {

    })
}

const validateSSN = (ssn) => {
    if (ssn.length !== 12) {
        return false;
    }

    ssn = ssn.substring(2, 12);

    var total = [];

    ssn.split('').slice(0, 9).forEach((value, index) => {
        var multi = 1;
        if (index % 2 == 0) {
            multi = 2;
        }
        total.push(value * multi);
    });


    var sum = total.join('').split('').reduce((acc, value) => {
        return parseInt(acc) + parseInt(value);
    });

    var control = (10 - (sum % 10)) % 10;
    return control == ssn[9];

}

const validateEmail = (email) => {
    return email.indexOf('@') >= 1 && email.indexOf('.') >= 1;
}

export const modelSearch = (dispatch, search) => {
    dispatch({
        type: 'MODEL_SEARCH',
        search: search
    })

    if (search.length >= 2) {

        let keywords = search.trim().split(' ');
        keywords = keywords.filter((keyword) => {
            return keyword.replace('\s', '').length > 0;
        });

        let models = [];

        store.getState().modelState.orgModels.forEach((model) => {

            var filters = [];

            if ((keywords.includes('man') || keywords.includes('män') || keywords.includes('kille') || keywords.includes('killar')) && model.ssn[10] % 2 == 1) {
                filters.push('man');
            } else if ((keywords.includes('kvinna') || keywords.includes('kvinnor') || keywords.includes('tjej') || keywords.includes('tjejer')) && model.ssn[10] % 2 == 0) {
                filters.push('woman');
            }

            keywords.some((keyword) => {
                if (keyword.match(/^([0-9]+\+)$/i)) {
                    var today = (new Date()).getFullYear();
                    var age = parseInt(model.ssn.substring(0, 4));
                    if (today - age >= parseInt(keyword)) {
                        filters.push('age');
                    }
                    return true;
                }
                if (keyword.match(/([0-9]+)-([0-9]+)/gi)) {
                    var matches = keyword.split('-');
                    var today = (new Date()).getFullYear();
                    var age = today - parseInt(model.ssn.substring(0, 4));
                    if (age >= parseInt(matches[0]) && age <= parseInt(matches[1])) {
                        filters.push('age');
                    }
                    return true;
                }
            })

            keywords.some((keyword) => {
                if (model.city.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                    filters.push('address');
                }
            });

            keywords.some((keyword) => {
                if (model.name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
                    filters.push('name');
                }
            });

            if (filters.length == keywords.length) {
                models.push(model);
            }

        })

        dispatch({
            type: 'MODEL_FILTER',
            models: models
        })
    } else {
        dispatch({
            type: 'MODEL_FILTER_DISABLE'
        })
    }
}

export const eventSearch = (dispatch, search) => {

    dispatch({
        type: 'EVENTS_SEARCH',
        search: search
    })

    if (search.length > 2) {

        let events = [];

        store.getState().eventState.orgEvents.forEach((event) => {
            var clientMatch = event.client.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            var titleMatch = event.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            var referenceMatch = event.reference.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            if (clientMatch || titleMatch || referenceMatch) {
                events.push(event);
            }
        });

        dispatch({
            type: 'EVENTS_FILTER',
            events: events
        });

    } else {

        dispatch({
            type: 'EVENTS_FILTER_DISABLE'
        });

    }
}

export const contractSearch = (dispatch, newFilter) => {

    let filter = {
        search: '',
        status: 0
    }

    let contracts = store.getState().contractState.orgContracts ? store.getState().contractState.orgContracts : [];

    if (store.getState().contractState.filter) {
        filter = { ...store.getState().contractState.filter, ...newFilter }
    } else {
        filter = { ...filter, ...newFilter }
    }

    if (filter.search.length > 2) {



        contracts = contracts.filter((contract) => {
            console.log(contract.ssn, contract);
            return  contract.event.title.toLowerCase().indexOf(filter.search.toLowerCase()) >= 0 ||
                    contract.event.reference.replace(/[\s-]/g, '').toLowerCase().indexOf(filter.search.replace(/[\s-]/g, '').toLowerCase()) >= 0 ||
                    contract.location.toLowerCase().indexOf(filter.search.toLowerCase()) >= 0 ||
                    contract.name.toLowerCase().indexOf(filter.search.toLowerCase()) >= 0 ||
                contract.ssn?.toLowerCase().indexOf(filter.search.toLowerCase()) >= 0;
        })

    }

    if (filter.status >= 0) {
        contracts = contracts.filter((contract) => {
            return contract.status === filter.status;
        })
    }

    dispatch({
        type: 'CONTRACT_FILTER',
        contracts: contracts,
        filter: filter
    })
}